import { render } from "./open.vue?vue&type=template&id=6fd2fa05&scoped=true"
import script from "./open.vue?vue&type=script&lang=js"
export * from "./open.vue?vue&type=script&lang=js"

import "./open.vue?vue&type=style&index=0&id=6fd2fa05&lang=scss&scoped=true"

import exportComponent from "D:\\projectAll\\cnb_2\\oulimojuxiaozhunxitong\\BOSS_GC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd2fa05"]])

export default __exports__